<script>
import getSecret from "@utils/get-secret";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import BaseDataTableRowSelect from "@components/BaseDataTableRowSelect";
import {
  authComputed,
  euroCouponsTutorialMethods,
  euroCouponsCouponMethods,
} from "@state/helpers";

export default {
  name: "EuroCouponsCouponIndex",
  page: {
    title: "Coupon",
    meta: [{ name: "description", content: getSecret("DESCRIPTION") }],
  },
  components: {
    Layout,
    PageHeader,
    BaseDataTableRowSelect,
    EuroCouponsCouponForm: () => import("@components/euro_coupons/coupon/Form"),
    EuroCouponsCouponDetail: () => import("@components/euro_coupons/coupon/Detail"),
    EuroCouponsCouponDelete: () => import("@components/euro_coupons/coupon/Delete"),
  },
  data() {
    return {
      title: this.$t("coupons"),
      items: [
        {
          text: this.$t("home"),
          href: "/",
        },
        {
          text: this.$t("coupons"),
          active: true,
        },
      ],
      tableHeaders: [],
      toUpdate: {},
      toDetail: {},
      toDelete: {},
      showForm: false,
      showDetail: false,
      showDelete: false,
      is_thirdparty_user: false,
      autogenerate: false,
    };
  },

  computed: {
    ...authComputed,
  },

  beforeMount() {
    const _ = this;
    let user_info = _.currentSession.user.user_info;

    _.is_thirdparty_user = user_info.is_thirdparty_user;
    _.autogenerate = user_info.thirdparty_info
      ? user_info.thirdparty_info.autogenerate_coupons
      : false;

    this.tableHeaders = [];
    if (!_.is_thirdparty_user) {
      this.tableHeaders = [
        ...this.tableHeaders,
        ...[
          { key: "selected", label: this.$t("selected") },
          { key: "cxc", label: this.$t("cxc") },
        ],
      ];
    }

    if (_.autogenerate || !_.is_thirdparty_user) {
      this.tableHeaders = [
        ...this.tableHeaders,
        ...[{ key: "code", label: this.$t("code") }],
      ];
    }

    if (!_.autogenerate || !_.is_thirdparty_user) {
      this.tableHeaders = [
        ...this.tableHeaders,
        ...[{ key: "beneficiary", label: this.$t("beneficiary") }],
      ];
    }

    this.tableHeaders = [
      ...this.tableHeaders,
      ...[
        {
          key: "value",
          label: this.$t("value"),
          formatter: (value) => {
            return this.$formatDollar(value);
          },
        },
        { key: "validity", label: this.$t("validity") },
        {
          key: "state",
          label: this.$t("state"),
          formatter: (value) => {
            return this.$t(value);
          },
        },
        { key: "redemption_information", label: this.$t("redemption_information") },
      ],
    ];

    if (!_.is_thirdparty_user) {
      this.tableHeaders = [
        ...this.tableHeaders,
        ...[
          { key: "CO", label: this.$t("CO") },
          { key: "cash_register", label: this.$t("cash_register") },
        ],
      ];
    }
  },

  mounted() {
    this.setShowTutorial(true);
    if (
      this.currentSession.user.groups_detail.some((group) => group.name === "aliados")
    ) {
      this.autogenerate
        ? this.setTutorialUrl("bonos_juju")
        : this.setTutorialUrl("bonos");
    } else {
      this.setTutorialUrl("bonos_administrativos");
    }
  },

  destroyed() {
    this.setShowTutorial(false);
  },

  methods: {
    ...euroCouponsTutorialMethods,
    ...euroCouponsCouponMethods,

    myProvider(ctx) {
      let context = this;
      const promise = context.fetchEuroCouponsCoupon(context.$table_params(ctx));
      return promise
        .then((data) => {
          return data;
        })
        .catch((error) => {
          context.$axios_error_noty(error, context);
          console.log(error);
          return [];
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-container fluid class="p-2">
      <b-row>
        <b-col>
          <!-- <b-card> -->
          <!-- <b-button
              variant="primary"
              size="sm"
              @click="()=>{showForm=true; toUpdate={}}"
            >
              <i class="fe-plus"></i> {{ $t('create') }}
            </b-button> -->

          <BaseDataTableRowSelect
            ref="table"
            :drfprovider="myProvider"
            :tableheaders="tableHeaders"
          >
            <template v-slot:cell(beneficiary)="row">
              <b-row>
                <b-col class="d-flex flex-column justify-content-center" sm="4">
                  <p class="p-0 m-0 font-weight-bold" style="white-space: nowrap">
                    {{
                      row.item.beneficiary
                        ? $capitalizeWords(row.item.beneficiary.name)
                        : "-"
                    }}
                  </p>
                  <i class="p-0 m-0" style="white-space: nowrap">
                    {{
                      row.item.beneficiary
                        ? `${row.item.beneficiary.document_type} ${row.item.beneficiary.document}`
                        : "-"
                    }}</i
                  >
                </b-col>

                <b-col
                  sm="1"
                  v-if="row.item.beneficiary && row.item.beneficiary.euro_employee"
                  class="mx-auto my-auto"
                >
                  <i
                    v-b-tooltip.hover="{
                      variant: 'primary',
                      placement: 'leftbottom',
                      title: $t('euro_employee'),
                    }"
                    class="fas fa-exclamation-circle text-primary"
                    style="font-size: 20px"
                  ></i>
                </b-col>
              </b-row>
            </template>
            <template v-slot:cell(redemption_information)="row">
              <b-row>
                <b-col class="d-flex flex-column justify-content-center">
                  <div v-if="row.item.redemption_date">
                    <p class="p-0 m-0">{{ $strfDatetime(row.item.redemption_date) }}</p>
                    <i class="p-0 m-0">{{
                      `${row.item["CO"]} - ${row.item.cash_register}`
                    }}</i>
                  </div>
                </b-col>
              </b-row>
            </template>

            <template v-slot:cell(validity)="row">
              <b-row>
                <b-col class="d-flex flex-column justify-content-center">
                  <p class="p-0 m-0"><span>Inicio:</span>{{ row.item.valid_from }}</p>
                  <p class="p-0 m-0"><span>Fin:</span>{{ row.item.expiration_date }}</p>
                </b-col>
              </b-row>
            </template>
            <template v-slot:cell(actions)="row">
              <b-button-group size="xs">
                <b-button
                  :id="`info-btn-${row.index}`"
                  v-b-tooltip.hover="{
                    variant: 'info',
                    placement: 'leftbottom',
                    title: $t('detail'),
                  }"
                  variant="btn-link text-info btn-transparent"
                  size="xs"
                  @click="
                    () => {
                      showDetail = true;
                      toDetail = row.item;
                    }
                  "
                >
                  <i class="fe-info fe-2x"></i>
                </b-button>

                <b-button
                  :id="`update-btn-${row.index}`"
                  v-b-tooltip.hover="{
                    variant: 'warning',
                    placement: 'leftbottom',
                    title: $t('edit'),
                  }"
                  variant="btn-link text-warning btn-transparent"
                  size="xs"
                  @click="
                    () => {
                      showForm = true;
                      toUpdate = row.item;
                    }
                  "
                >
                  <i class="fe-edit fe-2x"></i>
                </b-button>

                <b-button
                  :id="`delete-btn-${row.index}`"
                  v-b-tooltip.hover="{
                    variant: 'danger',
                    placement: 'leftbottom',
                    title: $t('delete'),
                  }"
                  variant="btn-link text-danger btn-transparent"
                  size="xs"
                  @click="
                    () => {
                      showDelete = true;
                      toDelete = row.item;
                    }
                  "
                >
                  <i class="fe-x fe-2x"></i>
                </b-button>
              </b-button-group>
            </template>
          </BaseDataTableRowSelect>

          <!-- </b-card> -->
        </b-col>
      </b-row>
    </b-container>

    <!-- Detail modal -->
    <EuroCouponsCouponDetail
      v-if="showDetail"
      :instanceJson="toDetail || {}"
      :oncomplete="
        () => {
          showDetail = false;
          toDetail = {};
        }
      "
      :oncancel="
        () => {
          showDetail = false;
          toDetail = {};
        }
      "
    >
    </EuroCouponsCouponDetail>

    <EuroCouponsCouponForm
      v-if="showForm"
      :fullform="true"
      :instanceJson="toUpdate || {}"
      :oncomplete="
        () => {
          showForm = false;
          toUpdate = {};
          $refs.table.refresh();
        }
      "
      :oncancel="
        () => {
          showForm = false;
          toUpdate = {};
        }
      "
    >
    </EuroCouponsCouponForm>

    <EuroCouponsCouponDelete
      v-if="showDelete"
      :instanceJson="toDelete"
      :oncomplete="
        () => {
          showDelete = false;
          toDelete = {};
          $refs.table.refresh();
        }
      "
      :oncancel="
        () => {
          showDelete = false;
          toDelete = {};
        }
      "
    >
    </EuroCouponsCouponDelete>
  </Layout>
</template>
